/* ================================================================
   UGOPAWA COUTURE — Header scroll behaviour
   assets/ugopawa-header.js
   ================================================================ */
(function () {
  'use strict';

  var THRESHOLD = 56;
  var header    = document.getElementById('ugp-site-header');
  if (!header) return;

  var ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(function () {
        header.classList.toggle('ugp-header--scrolled', window.scrollY > THRESHOLD);
        header.classList.toggle(
          'ugp-header--light-text',
          window.scrollY <= THRESHOLD && header.dataset.lightText === 'true'
        );
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
